// Simple frontend performance metrics collector (low risk, no deps)
type MetricEvent = {
  name: string
  ts: number
  data?: Record<string, any>
}

class FrontendMetricsService {
  private buffer: MetricEvent[] = []
  private max = 200

  mark(name: string, data?: Record<string, any>) {
    this.buffer.unshift({ name, ts: Date.now(), data })
    if (this.buffer.length > this.max) this.buffer = this.buffer.slice(0, this.max)
  }

  get recent(): MetricEvent[] {
    return this.buffer
  }

  // Limpia el buffer de eventos (útil para debugging en Dev Center)
  clear(): void {
    this.buffer = []
  }
}

export const feMetrics = new FrontendMetricsService()
export default feMetrics
